import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { ImageCropperService } from "src/app/core/services/image-cropper.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { AppleWalletPreferences } from "src/app/shared/models/AppleWalletPreferences.model";

@Component({
	selector: "app-gift-card-apple-wallet-setup",
	templateUrl: "./gift-card-apple-wallet-setup.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class GiftCardAppleWalletSetupComponent implements OnInit {
	@Input() changesToSave: boolean;
	@Output() changesToSaveChange = new EventEmitter<boolean>();

	@Input() walletPreferences: AppleWalletPreferences;
	@Output() walletPreferencesChange = new EventEmitter<AppleWalletPreferences>();

	timestamp: number;

	constructor(public app: AppService, private focuslink: FocuslinkService, public imgCrop: ImageCropperService, public venueService: OOVenueService) {}

	ngOnInit(): void {
		this.colorSelect("foreground");
		this.colorSelect("background");
	}

	async onImageComplete() {
		await this.app.references.delay(1000);
		this.timestamp = new Date().getTime();
	}

	colorSelect(section: string) {
		switch (section) {
			case "foreground":
				this.walletPreferences.foregroundColor = AppleWalletPreferences.fromPrimeNgColor(this.walletPreferences.foreground);
				this.walletPreferences.foregroundHex = this.app.references.colorRgbToHex(
					this.walletPreferences.foreground.r,
					this.walletPreferences.foreground.g,
					this.walletPreferences.foreground.b
				);
				break;
			case "background":
				this.walletPreferences.backgroundColor = AppleWalletPreferences.fromPrimeNgColor(this.walletPreferences.background);
				this.walletPreferences.backgroundHex = this.app.references.colorRgbToHex(
					this.walletPreferences.background.r,
					this.walletPreferences.background.g,
					this.walletPreferences.background.b
				);
				break;
			default:
				break;
		}
	}

	colorHexToRgb(section: string) {
		switch (section) {
			case "foreground":
				this.walletPreferences.foreground = this.app.references.colorHexToRgb(this.walletPreferences.foregroundHex);
				break;
			case "background":
				this.walletPreferences.background = this.app.references.colorHexToRgb(this.walletPreferences.backgroundHex);
				break;
		}
	}
}
